import type { SidebarState } from "./types";

const initialState = (): SidebarState => ({
  selectedTab: null,
  query: {
    data: null,
    error: null,
    loading: true,
    isLoaded: false,
    variables: {},
  },
  filterItems: {
    divisions: [{ label: "Loading", value: "", optionalLabel: undefined }],
    companies: [{ label: "Loading", value: "", optionalLabel: undefined }],
    jobs: [{ label: "Loading", value: "", optionalLabel: undefined }],
    locations: [{ label: "Loading", value: "", optionalLabel: undefined }],
    countries: [{ label: "Loading", value: "", optionalLabel: undefined }],
    teams: [{ label: "Loading", value: "", optionalLabel: undefined }],
    personTags: [{ label: "Loading", value: "", optionalLabel: undefined }],
    teamTypes: [{ label: "Loading", value: "", optionalLabel: undefined }],
  },
  filterItemSearch: {
    key: "",
    searchTerms: [],
  },
});

export default initialState;
